import { render } from "./NavbarHome.vue?vue&type=template&id=ec5d6cbc&ts=true"
import script from "./NavbarHome.vue?vue&type=script&lang=ts"
export * from "./NavbarHome.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__